import { createSlice } from "@reduxjs/toolkit";

import {getIndividualNotUsedLessons,
} from "redux/actions/studentLessons";
import {IReservationIndividualNotUsedLesson} from "../../types/redux/reservation";

export interface IReservationIndividualNotUsed {
    reservationIndividualNotUsed: IReservationIndividualNotUsedLesson[]|null;
    loading:boolean
}

const initial: IReservationIndividualNotUsed = {
    reservationIndividualNotUsed:null,
    loading:false
};

export const reservationIndividualNotUsedSlice = createSlice({
    name: "reservationIndividualNotUsedSlice",
    initialState: initial,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getIndividualNotUsedLessons.pending, (state, action) => {
            state.loading= true;
        });
        builder.addCase(getIndividualNotUsedLessons.fulfilled, (state, action) => {
            state.loading = false;
            state.reservationIndividualNotUsed = action.payload;
        });
        builder.addCase(getIndividualNotUsedLessons.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export const {} = reservationIndividualNotUsedSlice.actions;

export default reservationIndividualNotUsedSlice.reducer;
